export const COMPARISON_1_CONSTANTS = {
  DEFAULT_ROW: {
    id: "1",
    meta_criteria_name: "UGC-Recognized MBA Degree",
    meta_criteria_text_color: "#FFFFFF",
    meta_criteria_background_color: "#FFFFFF1A",
    meta_column1_text: "",
    meta_column1_text_color: "",
    meta_column1_image: "",
    meta_column1_alt_image: "image1",
    meta_column1_background_color: "#02A7B633",
    meta_column2_text: "",
    meta_column2_text_color: "",
    meta_column2_image: "",
    meta_column2_alt_image: "image1",
    meta_column2_background_color: "#02A7B633",
    meta_column3_text: "",
    meta_column3_text_color: "",
    meta_column3_image: "",
    meta_column3_alt_image: "image1",
    meta_column3_background_color: "#02A7B633",
    meta_priority: 1,
    meta_status: 1,
  },

  METADATA_TITLES: {
    metadata: "Comparison Rows",
  },

  COMPARISON_FIELDS_CONFIG: [
    {
      fieldName: "desktop_background_color",
      label: "Desktop Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter desktop background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "mobile_background_color",
      label: "Mobile Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter mobile background color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "backvariant",
      label: "Background Variant",
      value: "variant_1",
      valueType: "string",
      filedType: "SELECT",
      placeholder: "Select Background Variant",
      required: true,
      defaultValue: "variant_1",
      className: "h-9 py-1.5 text-sm",
      iconClassName: "!size-4",
      options: [
        { label: "Variant 1", value: "variant_1" },
        { label: "Variant 2", value: "variant_2" },
        { label: "Variant 3", value: "variant_3" },
      ],
    },
    {
      fieldName: "gradient_color_1",
      label: "Gradient Color 1",
      value: "#5345C3",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#5345C3",
      required: false,
      defaultValue: "#5345C3",
    },
    {
      fieldName: "gradient_color_2",
      label: "Gradient Color 2",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_3",
      label: "Gradient Color 3",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "gradient_color_4",
      label: "Gradient Color 4",
      value: "#00D4EB",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#00D4EB",
      required: false,
      defaultValue: "#00D4EB",
    },
    {
      fieldName: "pre_title",
      label: "Pre Title",
      value: "Why Online ",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Pre Title",
      required: false,
      defaultValue: "Why Online ",
    },
    {
      fieldName: "pre_title_color",
      label: "Pre Title Color",
      value: "#FFFFFFCC",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter pre title color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFFCC",
    },
    {
      fieldName: "title",
      label: "Title",
      value: "MBA Stands Out",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Title",
      required: false,
      defaultValue: "MBA Stands Out",
    },
    {
      fieldName: "title_start_color",
      label: "Title Start Color (Gradient)",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "title_end_color",
      label: "Title End Color (Gradient)",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#02A7B6",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "title_gradient_angle",
      label: "Title Gradient Angle",
      value: "90deg",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter gradient angle (e.g., 90deg, 180deg)",
      required: false,
      defaultValue: "90deg",
    },
    {
      fieldName: "description",
      label: "Description",
      value: "We've reimagined online business education. Here's how we're different from typical programs.",
      valueType: "string",
      filedType: "TEXT_AREA",
      placeholder: "Enter Description",
      required: false,
      defaultValue: "We've reimagined online business education. Here's how we're different from typical programs.",
    },
    {
      fieldName: "description_text_color",
      label: "Description Text Color",
      value: "#FFFFFFB2",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFFB2",
      required: false,
      defaultValue: "#FFFFFFB2",
    },
    {
      fieldName: "column1",
      label: "Column 1 Header",
      value: "Online MBA",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Column 1 header",
      required: false,
      defaultValue: "Online MBA",
      description:
        "Leave this header and all of its row values empty to hide this column.",
    },
    {
      fieldName: "column1_text_color",
      label: "Column 1 Text Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "column1_background_color",
      label: "Column 1 Background Color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#02A7B6",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "column2",
      label: "Column 2 Header",
      value: "Traditional Online MBA",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Column 2 header",
      required: false,
      defaultValue: "Traditional Online MBA",
      description:
        "Leave this header and all of its row values empty to hide this column.",
    },
    {
      fieldName: "column2_text_color",
      label: "Column 2 Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "column2_background_color",
      label: "Column 2 Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "column3",
      label: "Column 3 Header",
      value: "Standalone CFP® Programs",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter Column 3 header",
      required: false,
      defaultValue: "Standalone CFP® Programs",
      description:
        "Leave this header and all of its row values empty to hide this column.",
    },
    {
      fieldName: "column3_text_color",
      label: "Column 3 Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#FFFFFF",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "column3_background_color",
      label: "Column 3 Background Color",
      value: "#000000",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "#000000",
      required: false,
      defaultValue: "#000000",
    },
    {
      fieldName: "cta_text",
      label: "CTA Text",
      value: "Apply Now",
      valueType: "string",
      filedType: "INPUT",
      placeholder: "Enter CTA button text",
      required: false,
      defaultValue: "Apply Now",
    },
    {
      fieldName: "cta_text_color",
      label: "CTA Text Color",
      value: "#FFFFFF",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA text color (e.g., #FFFFFF)",
      required: false,
      defaultValue: "#FFFFFF",
    },
    {
      fieldName: "cta_background_color",
      label: "CTA Background Color",
      value: "#02A7B6",
      valueType: "string",
      filedType: "COLOR",
      placeholder: "Enter CTA background color (e.g., #02A7B6)",
      required: false,
      defaultValue: "#02A7B6",
    },
    {
      fieldName: "status",
      label: "Comparison Section Status",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable Comparison Section",
      defaultValue: false,
    },
    {
      fieldName: "enable_animation",
      label: "Enable Animation",
      value: false,
      valueType: "boolean",
      filedType: "TOGGLE",
      placeholder: "Enable/Disable animation",
      required: false,
      defaultValue: false,
    },
  ],

  METADATA_FIELDS: [
    { 
      header: "Criteria Name", 
      fieldName: "meta_criteria_name", 
      value: "", valueType: "string", 
      filedType: "INPUT", 
      placeholder: "e.g. UGC-Recognized MBA Degree", 
      required: false 
    },
    { 
      header: "Criteria Text Color", 
      fieldName: "meta_criteria_text_color", 
      value: "#FFFFFF", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "#FFFFFF", 
      required: false,
      defaultValue: "#FFFFFF",
    },
    { 
      header: "Criteria Background", 
      fieldName: "meta_criteria_background_color", 
      value: "#FFFFFF1A", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "#FFFFFF1A", 
      required: false,
      defaultValue: "#FFFFFF1A",
    },
    { 
      header: "Column 1 Text", 
      fieldName: "meta_column1_text", 
      value: "", 
      valueType: "string", 
      filedType: "INPUT", 
      placeholder: "Column 1 content", 
      required: false,
      defaultValue: "",
    },
    { 
      header: "Column 1 Text Color", 
      fieldName: "meta_column1_text_color", 
      value: "", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "", 
      required: false,
      defaultValue: "",
    },
    { 
      header: "Column 1 Image", 
      fieldName: "meta_column1_image", 
      value: "", 
      valueType: "string", 
      filedType: "FILE", 
      placeholder: "Upload image", 
      required: false,
      defaultValue: "",
    },
    { 
      header: "Column 1 Alt", 
      fieldName: "meta_column1_alt_image", 
      value: "image1", 
      valueType: "string", 
      filedType: "INPUT", 
      placeholder: "Alt text", 
      required: false,
      defaultValue: "image1",
    },
    { 
      header: "Column 1 BG Color", 
      fieldName: "meta_column1_background_color", 
      value: "#02A7B633", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "#02A7B633", 
      required: false,
      defaultValue: "#02A7B633",
    },
    { 
      header: "Column 2 Text", 
      fieldName: "meta_column2_text", 
      value: "", valueType: "string", 
      filedType: "INPUT", 
      placeholder: "Column 2 content", 
      required: false,
      defaultValue: "",
    },
    { 
      header: "Column 2 Text Color", 
      fieldName: "meta_column2_text_color", 
      value: "", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "", 
      required: false,
      defaultValue: "",
    },
    { 
      header: "Column 2 Image", 
      fieldName: "meta_column2_image", 
      value: "", 
      valueType: "string", 
      filedType: "FILE", 
      placeholder: "Upload image", 
      required: false,
      defaultValue: "",
    },
    { 
      header: "Column 2 Alt", 
      fieldName: "meta_column2_alt_image", 
      value: "image1", 
      valueType: "string", 
      filedType: "INPUT", 
      placeholder: "Alt text", 
      required: false,
      defaultValue: "image1",
    },
    { 
      header: "Column 2 BG Color", 
      fieldName: "meta_column2_background_color", 
      value: "#02A7B633", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "#02A7B633", 
      required: false,
      defaultValue: "#02A7B633",
    },
    { 
      header: "Column 3 Text", 
      fieldName: "meta_column3_text", 
      value: "", 
      valueType: "string", 
      filedType: "INPUT", 
      placeholder: "Column 3 content", 
      required: false,
      defaultValue: "",
    },
    { header: "Column 3 Text Color", 
      fieldName: "meta_column3_text_color", 
      value: "", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "", 
      required: false,
      defaultValue: "",
    },
    { 
      header: "Column 3 Image", 
      fieldName: "meta_column3_image", 
      value: "", 
      valueType: "string", 
      filedType: "FILE", 
      placeholder: "Upload image", 
      required: false,
      defaultValue: "",
    },
    { 
      header: "Column 3 Alt", 
      fieldName: "meta_column3_alt_image", 
      value: "image1", 
      valueType: "string", 
      filedType: "INPUT", 
      placeholder: "Alt text", 
      required: false,
      defaultValue: "image1",
    },
    { 
      header: "Column 3 BG Color", 
      fieldName: "meta_column3_background_color", 
      value: "#02A7B633", 
      valueType: "string", 
      filedType: "COLOR", 
      placeholder: "#02A7B633", 
      required: false,
      defaultValue: "#02A7B633",
    },
    { header: "Priority", 
      fieldName: "meta_priority", 
      value: 1, 
      valueType: "number", 
      filedType: "INPUT", 
      placeholder: "Enter Priority", 
      required: true,
      defaultValue: 1,
    },
    { header: "Status", 
      fieldName: "meta_status", 
      value: 1, 
      valueType: "number", 
      filedType: "INPUT", 
      placeholder: "1 = active", 
      required: false,
      defaultValue: 1,
    },
  ],
};
